import { SoStatusEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";

export class PostShipmentDetailsDto{
    @ApiProperty()
    postShipmentId: number;
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    vesselNo:number;
    @ApiProperty()
    vesselName: string;
    @ApiProperty()
    marksNo: string;
    @ApiProperty()
    dateOfIssue: Date;
    @ApiProperty()
    lcNo: string;
    @ApiProperty()
    lcName: string;
    @ApiProperty()
    lcBankAddress: string;
    @ApiProperty()
    lcAmount: number;
    @ApiProperty()
    isActive?: boolean;
    @ApiProperty()
    createdUser?: string | null;
    @ApiProperty()
    updatedUser?: string | null;
}